import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { InfrastructureCreatePage } from '@/features/admin/infrastructures/infrastructure-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvelle infrastructure (mode in-cluster seulement, revue RT-02). */
export const Route = createFileRoute('/$tenant/resources/infrastructures/new')({
  component: NewInfrastructureRoute,
});

function NewInfrastructureRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="infrastructures"
      crumbs={[{ label: t('nav.items.infrastructures') }, { label: t('admin.infrastructures.newTitle') }]}
    >
      <InfrastructureCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
